export default {
  retrieveNotificationGroupList (state, payload) {
    state.notificationGroupList = payload.notificationGroupList

  },
  // addClassToList (state, payload) {
  //   state.classList.push(payload.student)
  // },
  getNotificationGroupInfo (state, payload) {
    state.notificationGroupInfo = payload.notificationGroupInfo
  },
  deleteNotificationGroup (state, payload) {
    state.notificationGroupList.splice(payload.notificationGroupInfo.index, 1);
  }
}
